import { FeedbackComponentConfig } from '../../../../shared/components/feedback-collection/feedback-collection.models';

export const claimsTrackerFeedbackConfig: FeedbackComponentConfig = {
  activeStage: 0,
  selectedValue: [],
  finishFormValue: 3,
  stages: {
    0: {
      title: {
        text: "We'd like to hear your feedback",
      },
      description: 'Have we made it easy to manage your booking?',
      options: [
        {
          value: 'Yes',
          label: 'Yes',
          icon: 'thumbs-up',
        },
        {
          value: 'No',
          label: 'No',
          icon: 'thumbs-down',
        },
      ],
    },
    1: {
      activeWhenPreviousValueIs: 'No',
      title: {
        text: 'Please tell us why',
      },
      button: {
        text: 'Send your reason',
      },
      options: [
        {
          value: 'Information displayed isn’t right',
          label: 'Information displayed isn’t right',
        },
        {
          value: 'Phone number doesn’t work',
          label: 'Phone number doesn’t work',
        },
        {
          value: 'I can’t use my preferred contact method',
          label: 'I can’t use my preferred contact method',
        },
        {
          value: 'Important information is missing',
          label: 'Important information is missing',
        },
        {
          value: 'My problem isn’t listed',
          label: 'My problem isn’t listed',
        },
        {
          value: 'I’d prefer not to say',
          label: 'I’d prefer not to say',
        },
      ],
    },
    2: {
      activeWhenPreviousValueIs: 'My problem isn’t listed',
      title: {
        text: 'Tell us more about the problem',
      },
      description:
        'Please don’t share any personal details (like your phone number or address). Right now, we’re only using this feedback to improve our website.',
      button: {
        text: 'Send your reason',
      },
      freeTextInput: true,
      maxCharCount: 500,
    },
    3: {
      title: {
        text: 'Thanks for your feedback',
        icon: 'thumbs-up',
        classes: 'success',
      },
    },
  },
};
